import { css } from "styled-components";
import { KEYBOARD_FOCUS_OUTLINE } from "./materials/colors";
import { dp } from "./materials/metrics";

export const focusOutlineStyles = () => css`
  &:focus-visible {
    outline: ${dp(2)} solid ${KEYBOARD_FOCUS_OUTLINE};
  }
`;
